import { combineReducers } from '@reduxjs/toolkit'
import themeSlice from './theme/slice'
import metaSlice from './meta/slice'
import hostingPlansSlice from './hosting-plans/slice'
import domainSlice from './domain/slice'
import vpsPlansSlice from './vps-plans/slice'
import orderSlice from './order/slice'
import captchaSlice from './captcha/slice'
import dedicatedPlansSlice from './dedicated-plans/slice'
import constructorDataSlice from './constructor/slice'
import sslCertificatesSlice from './ssl-certificates/slice'
import helpSlice from './help/slice'
import paymentMethodsSlice from './payment-methods/slice'
import appTypesSlice from './app-types/slice'

export const rootReducer = combineReducers({
  theme: themeSlice.reducer,
  meta: metaSlice.reducer,
  hostingPlans: hostingPlansSlice.reducer,
  domain: domainSlice.reducer,
  vpsPlans: vpsPlansSlice.reducer,
  order: orderSlice.reducer,
  captcha: captchaSlice.reducer,
  dedicatedPlans: dedicatedPlansSlice.reducer,
  constructorData: constructorDataSlice.reducer,
  sslCertificates: sslCertificatesSlice.reducer,
  helpData: helpSlice.reducer,
  paymentMethods: paymentMethodsSlice.reducer,
  appTypes: appTypesSlice.reducer,
})
